import React from "react";

import { usePageTitleEffect } from "@/components/AppProvider/AppOrgsAndInvitedOrgsProvider";
import { FrontendAddonFormCreate } from "@/components/FrontendAddonForm/FrontendAddonFormCreate";
import { FrontendAddonHeader } from "@/components/FrontendAddonHeader";
import { AppTopNavSlot } from "../../components/AppTopNav";
import { ErrorWrapper } from "../../components/ErrorWrapper";
import styles from "../index.module.css";

export const PageAdminFrontendMastersCreate: React.FC = () => {
  usePageTitleEffect("フロントエンドアドオンマスタ作成");
  return (
    <div className={styles.root}>
      <div>
        <AppTopNavSlot>
          <FrontendAddonHeader
            parentTitle="フロントエンドアドオンマスタ"
            listPath="/admin/frontendmasters"
          />
        </AppTopNavSlot>
      </div>
      <div className={styles.pageContent}>
        <ErrorWrapper>
          <FrontendAddonFormCreate returnPath="/admin/frontendmasters" />
        </ErrorWrapper>
      </div>
    </div>
  );
};
